import React from 'react';

export const LineDivider = () => (
  <svg width="550" height="1" viewBox="0 0 550 1" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line x1="5.21403e-08" y1="0.25" x2="550" y2="0.250115" stroke="#E3E3E3" strokeWidth="0.5"/>
  </svg>
);
